import { useState } from "react";
import { IndexName } from "../../../../../constants/constants";
import "../../../Index.scss";
import { isMobile } from "../../../../../utils/globalUtilities";

export const DocumentIntro = ({item, index, getQuikInfoData, setActiveIndex, activeIndex}:any) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = (e: React.MouseEvent) => {
    e.preventDefault();
    setActiveIndex(index)
    setIsOpen((prevState) => !prevState);
    getQuikInfoData(item.Id, index, item.Index);
  };

  return (
    <span className="dropdowns group-list-short-des" key={`DocumentIntro${index}`} >
      <a 
        className={`svg-links ${isOpen && activeIndex == index ? 'svg-active' : ''}`}
        onClick={isMobile() ? handleToggle : undefined} 
        onMouseEnter={(e) => {
          e.preventDefault()
          getQuikInfoData(item.Id, index, item.Index)
        }} >
        <svg
          width="48"
          height="33"
          viewBox="0 0 48 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect className="react-1" x="0.5" y="1.00024" width="47" height="31" rx="15.5" fill="#F6F6F6" />
          <rect className="react-2" x="0.5" y="1.00024" width="47" height="31" rx="15.5" stroke="#C9C9C9" />
          <path
            d="M18.0891 17.7803H21.1791V24.9803C21.1791 26.6603 22.0891 27.0003 23.1991 25.7403L30.7691 17.1403C31.6991 16.0903 31.3091 15.2203 29.8991 15.2203H26.8091V8.02026C26.8091 6.34026 25.8991 6.00026 24.7891 7.26026L17.2191 15.8603C16.2991 16.9203 16.6891 17.7803 18.0891 17.7803Z"
            stroke="#C9C9C9"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </a>
      {item?.docIntro?.length && (isMobile()  ? isOpen && activeIndex == index : true) ? (
        item.Index === IndexName.practice ? (
          <span className={`dropdown-contents exp-details rrrrrrrr ${isOpen ? 'dropdown-content-active' : ''}`}>
            <h2 className="exp-h2">
              {" "}
              {item?.docIntro?.[0]?.heading || item?.heading || ''}{" "}
            </h2>
            <span className="max-c-scroll-1">
              <p>
                {" "}
                {item?.docIntro?.[0]?.introduction || item?.thirdLine || ''}{" "}
              </p>
            </span>
          </span>
        ) : (
          <span className={`dropdown-contents exp-details Hyt ${isOpen ? 'dropdown-content-active' : ''}`}>
            <h2 className="exp-h2">
              {" "}
              {item?.heading}{" "}
            </h2>
            <span className="max-c-scroll-1">
              {" "}
              {item?.docIntro?.length
                ? item?.docIntro.map((contentData: string) => (
                    <p>{contentData}</p>
                  ))
                : ""}
            </span>
          </span>
        )
      ) : null}
    </span>
  );
};

export default DocumentIntro;
